import React from "react";
import MainLayout from "../../../components/MainLayout";
import ListaDeAplicaciones from "./components/ListaDeAplicaciones";

const Home = () => {
  return (
    <MainLayout>
      <div className="row title_layout">
        <div className="col-6">
          <h5>LISTA DE SOLICITUDES</h5>
        </div>
      </div>
      <ListaDeAplicaciones />
    </MainLayout>
  );
};

export default Home;
